import { forwardRef, useState } from "react";
import { Button, Tooltip } from "@timeedit/ui-components/antd";
import { TOOLTIP_DELAY } from "../../lib/UIConstants";

type TTooltippedTopbarButtonProps = {
    tooltip: string;
    icon: JSX.Element;
    onClick: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

const TooltippedTopbarButton = forwardRef<HTMLDivElement, TTooltippedTopbarButtonProps>(
    ({ tooltip, icon, onClick }, ref) => {
        const [tooltipOpen, setTooltipOpen] = useState(false);

        return (
            <Tooltip
                mouseEnterDelay={TOOLTIP_DELAY}
                title={tooltip}
                open={tooltipOpen}
                onOpenChange={setTooltipOpen}
            >
                <div
                    ref={ref}
                    className={`tw:h-full tw:flex tw:items-center tw:justify-center tw:overflow-hidden tw:text-inherit tw:leading-[0]`}
                >
                    <Button
                        type="text"
                        className="tooltippedTopbarButton user-dropdown-trigger-button"
                        onClick={(e) => {
                            e.preventDefault();
                            setTooltipOpen(false);
                            onClick(e);
                        }}
                    >
                        {icon}
                    </Button>
                </div>
            </Tooltip>
        );
    }
);

export default TooltippedTopbarButton;
